module.exports = __webpack_public_path__ + "static/media/7.e2376b6c.jpeg";